<template>
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{title}}
          </h3>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table class="table align-items-center table-flush"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  tbody-classes="list"
                  :data="data">
        <template slot="columns">
          <th>Banco</th>
          <th>Total adeudado</th>
          <th>Con DB Menos</th>
          <th>Liquidada en mes</th>
        </template>

        <template slot-scope="{row}">
          <th scope="row">
            <div class="avatar-group">
              <a class="avatar avatar-sm rounded-circle" style="background-color: #FFFFFF" data-toggle="tooltip" :data-original-title="row.bank.name">
                <img :alt="row.bank.name" :src="row.bank.url">
              </a>
            </div>
          </th>
          <td>{{$formatCurrency(row.amount)}}</td>
          <td>{{$formatCurrency(row.willPay)}}</td>
          <td>{{row.willPayOnMonth}}</td>
        </template>

      </base-table>
    </div>

  </div>
</template>
<script>
  export default {
    name: 'clients-table',
    props: {
      type: {
        type: String
      },
      title: String,
      data: Array,
      pagination: Object
    },
    data() {
      return {
        tableData: [],
      }
    },
    computed: {
      banks() { return this.$store.state.banks }
    },
    async created() { },
    methods: {
      pageSelected(page) {
        this.$emit("pageSelected", page);
      },
      getValidatedClass(validated) {
        if (validated) return "text-success"
        return "text-danger"
      },
      formatCurrency(value) {
        return this.$formatCurrency(value)
      },
      getBanks(array) {
        let banks = []
        for (let a=0 ; a<=array.length ; a++) {
          for (let b = 0; b < this.banks.length; b++) {
            if (this.banks[b].id === array[a]) {
              banks.push(this.banks[b])
              break
            }
          }
        }
        return banks
      },
      formatDate(date) {
        return this.$moment(date).format("DD MMM, YYYY")
      },
      onNewItem() {
        this.$emit("onNewItem")
      },
      setEditMode(row, edit) {
        for (let i=0 ; i<this.tableData.length ; i++)
          this.tableData[i].editMode = false
        row.editMode = edit
        this.$forceUpdate()
      }
    }
  }
</script>
<style>
</style>
